const VERSION = '2.9.1';
export function getVersionString() {
    return VERSION;
}
